import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { ICreatePhoneCenterForm, IPostNewPhoneCenter } from '../phoneCenter';


const mapPhoneCenterToApiPhoneCenterDto = (values: ICreatePhoneCenterForm): IPostNewPhoneCenter | {} => {
  let dataMapping: IPostNewPhoneCenter;
 
  if (values.providers == undefined){return {}}

    dataMapping = {
      description: values.description,    
      phoneCentersSysModelId: +values.phoneCentersSysModelId,
      phoneCentersMaintenanceId: +values.phoneCentersMaintenanceId,
      unitID: +values.unitID,
      incomingLines: values.incomingLines,
      outgoingLines: values.outgoingLines,
      channelNumber: values.channelNumber,
      workstaions: values.workstaions,
      elevatorNumber: values.elevatorNumber,
      fctNumber: values.fctNumber,
      errorCode: values.errorCode,
      internalsNumber: values.internalsNumber,
      comments: values.comments,
      fileLink: values.fileLink,
      isPSTN: values.isPSTN,
      isISDN: values.isISDN,
      is30PRI: values.is30PRI,
      isLine: values.isLine,
      providers: values.providers.map(provider => Number(provider.value))
    }
  
    console.log("sended values", dataMapping)
  return dataMapping;
}


export const createPhoneCenter = ( {data} : {data: ICreatePhoneCenterForm }): Promise<string> => {
  const phoneCenter = mapPhoneCenterToApiPhoneCenterDto(data);
  return axiosDefaultApi.post(`/api/PhoneCenters/InsertPhoneCenter`, phoneCenter);
};

type QueryFnType = typeof createPhoneCenter;

type UseCreatePhoneCenterOptions = {
  data: IPostNewPhoneCenter | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreatePhoneCenter = ({ config }: UseCreatePhoneCenterOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία του Τηλεφωνικού Κέντρου.`, 500);
            console.error('Couldnt create new store', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllPhoneCenters"])
            addNotification(`Το Τηλεφωνικό Κέντρο Δημιουργήθηκε.`, 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createPhoneCenter,
    })
}